import axios from 'axios';
import {
  getAuthToken,
  clearAuthAndRedirect,
  isPublicAuthRequest,
  getApiErrorMessage,
} from './auth';

let interceptorsRegistered = false;

function hasAuthHeader(headers) {
  if (!headers) return false;
  const h = typeof headers.get === 'function' ? headers : headers;
  return Boolean(h.authorization || h.Authorization);
}

export function setupAxiosInterceptors() {
  if (interceptorsRegistered) return;
  interceptorsRegistered = true;

  axios.interceptors.request.use((config) => {
    const token = getAuthToken();
    const url = config.url || '';

    if (token && !isPublicAuthRequest(url) && !hasAuthHeader(config.headers)) {
      config.headers = config.headers || {};
      config.headers.authorization = `bearer ${token}`;
    }

    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url || '';

      if (status === 401 && !isPublicAuthRequest(url)) {
        const hadToken =
          Boolean(getAuthToken()) ||
          Boolean(
            error?.config?.headers?.authorization ||
              error?.config?.headers?.Authorization
          );

        error.friendlyMessage = getApiErrorMessage(
          error,
          'Session expired. Please sign in again.'
        );

        if (hadToken) {
          clearAuthAndRedirect(error.friendlyMessage);
        }
      } else if (status === 403) {
        error.friendlyMessage = getApiErrorMessage(
          error,
          'Unauthorized access.'
        );
      }

      return Promise.reject(error);
    }
  );
}
